import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomModal, SpinnerLoader } from "@services/ui-components";

interface ConfirmPublishMenuModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    menuTypeName?: string;
    loading?: boolean;
}

const ConfirmPublishMenuModal: React.FC<ConfirmPublishMenuModalProps> = ({
    show,
    onClose,
    onConfirm,
    menuTypeName,
    loading,
}) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            show={show}
            handleClose={onClose}
            title={
                <Container>
                    <Row>
                        <h5 className="m-0 p-0 fw-normal">{t("Publish the menu?")}</h5>
                    </Row>
                </Container>
            }
            body={
                <Container>
                    <Row>
                        <Col>
                            <span className="fs-16 text-dark">
                                {t("Once published, this menu will be accessible via the {{menuTypeName}} QR code.", {
                                    menuTypeName,
                                })}
                            </span>
                        </Col>
                    </Row>
                </Container>
            }
            buttons={[
                {
                    text: t("Cancel"),
                    onClick: onClose,
                    variant: "outline-primary",
                    className: "w-100 fw-normal",
                },
                {
                    text: loading ? <SpinnerLoader variant="light" loadingText={t("Loading...")} /> : t("Publish"),
                    onClick: onConfirm,
                    variant: "primary",
                    className: "w-100 fw-bold",
                    disabled: loading,
                },
            ]}
        />
    );
};

export default ConfirmPublishMenuModal;
